// extracted by mini-css-extract-plugin
export var attribution = "_dd-4";
export var authorName = "_dd-5";
export var quote = "_dd-3";
export var testimonial = "_dd-2";
export var trustedBy = "_dd-0";
export var trustedByLabel = "_dd-1";